module.exports = __webpack_public_path__ + "img/alfy-logo-completo-300.6179a7e5.png";